import { UI_SVG_HOST_TAGS } from '../host-tags';
const svgTagSet = new Set(UI_SVG_HOST_TAGS);
const hostTagByType = Object.freeze({
    Stack: 'div',
    StackRow: 'div',
    StackCol: 'div',
    Flex: 'div',
    Grid: 'div',
    GridItem: 'div',
    Box: 'div',
    ScrollArea: 'div',
    Spacer: 'div',
    Divider: 'span',
    Text: 'span',
    Heading: 'h2',
    Label: 'label',
    Code: 'code',
    CodeBlock: 'div',
    Button: 'button',
    ButtonGroup: 'div',
    Link: 'a',
    NavTree: 'nav',
    NavTreeSection: 'section',
    NavTreeItem: 'li',
    Breadcrumb: 'nav',
    BreadcrumbList: 'ol',
    BreadcrumbItem: 'li',
    BreadcrumbLink: 'a',
    BreadcrumbCurrentLink: 'span',
    BreadcrumbSeparator: 'li',
    BreadcrumbEllipsis: 'li',
    Field: 'div',
    FieldLabel: 'label',
    FieldDescription: 'div',
    FieldError: 'div',
    FieldGroup: 'div',
    FieldSet: 'fieldset',
    FieldLegend: 'legend',
    InputCharacterCount: 'span',
    TextInput: 'input',
    Textarea: 'textarea',
    Checkbox: 'input',
    CheckboxGroup: 'div',
    Radio: 'input',
    RadioGroup: 'div',
    Switch: 'input',
    Select: 'select',
    Flyout: 'div',
    FlyoutItem: 'div',
    DropdownMenu: 'div',
    DropdownMenuTrigger: 'button',
    DropdownMenuContextTrigger: 'div',
    DropdownMenuContent: 'div',
    DropdownMenuItem: 'div',
    DropdownMenuCheckboxItem: 'div',
    DropdownMenuRadioGroup: 'div',
    DropdownMenuRadioItem: 'div',
    DropdownMenuGroup: 'div',
    DropdownMenuLabel: 'div',
    DropdownMenuSeparator: 'div',
    DropdownMenuShortcut: 'span',
    DropdownMenuSub: 'div',
    DropdownMenuSubTrigger: 'div',
    DropdownMenuSubContent: 'div',
    Modal: 'div',
    ModalTrigger: 'button',
    ModalBackdrop: 'div',
    ModalPositioner: 'div',
    ModalContent: 'div',
    ModalHeader: 'div',
    ModalTitle: 'h2',
    ModalDescription: 'p',
    ModalBody: 'div',
    ModalFooter: 'div',
    ModalCloseTrigger: 'button',
    ModalActionTrigger: 'button',
    Table: 'table',
    TableScrollArea: 'div',
    TableCaption: 'caption',
    TableColumnGroup: 'colgroup',
    TableColumn: 'col',
    TableHeader: 'thead',
    TableBody: 'tbody',
    TableFooter: 'tfoot',
    TableRow: 'tr',
    TableColumnHeader: 'th',
    TableCell: 'td',
    Chart: 'section',
    Tabs: 'div',
    TabsList: 'div',
    TabsTrigger: 'button',
    TabsContent: 'div',
    Accordion: 'div',
    AccordionItem: 'div',
    AccordionTrigger: 'button',
    AccordionIndicator: 'span',
    AccordionContent: 'div',
    AccordionBody: 'div',
    SegmentedControl: 'div',
    Spinner: 'span',
    Progress: 'progress',
    Alert: 'div',
    Toast: 'div',
    Toaster: 'div',
    Fragment: 'div',
});
export function createNode(node, document) {
    if (node.type === 'TextNode') {
        return document.createTextNode(node.text ?? '');
    }
    if (node.type === 'Fragment') {
        return document.createComment('smth-fragment');
    }
    const tag = mapTypeToTag(node.type, node.props);
    const element = isSvgTag(tag)
        ? document.createElementNS('http://www.w3.org/2000/svg', tag)
        : document.createElement(tag);
    return element;
}
export function isSvgTag(tag) {
    return svgTagSet.has(tag);
}
export function mapTypeToTag(type, props) {
    if (!type) {
        return 'div';
    }
    if (type === 'Text' || type === 'Code' || type === 'Box' || type === 'Flex' || type === 'Stack' || type === 'StackRow' || type === 'StackCol' || type === 'Grid' || type === 'GridItem' || type === 'Spacer' || type === 'Divider' || type === 'ScrollArea' || type === 'Breadcrumb' || type === 'BreadcrumbList' || type === 'BreadcrumbItem' || type === 'BreadcrumbLink' || type === 'BreadcrumbCurrentLink' || type === 'BreadcrumbSeparator' || type === 'BreadcrumbEllipsis') {
        const semanticTag = props?.['data-as'];
        if (typeof semanticTag === 'string' && semanticTag.length > 0) {
            return semanticTag;
        }
    }
    if (type === 'Heading') {
        const semanticLevel = Number(props?.['data-level']);
        if (Number.isInteger(semanticLevel) && semanticLevel >= 1 && semanticLevel <= 6) {
            return `h${semanticLevel}`;
        }
    }
    if ((type === 'Checkbox' && props?.['data-checkbox-root'] === 'true')
        || (type === 'Radio' && props?.['data-radio-root'] === 'true')
        || (type === 'Switch' && props?.['data-switch-root'] === 'true')) {
        return 'span';
    }
    if (type === 'Select' && props?.['data-select-trigger'] === 'true') {
        return 'button';
    }
    return hostTagByType[type] ?? (isSvgTag(type) ? type : type.toLowerCase() === type ? type : 'div');
}
//# sourceMappingURL=node-factory.js.map